/* global __DEV__ */
import { applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import { fetcherMiddleware as createFetcherMiddleware } from '@traveloka/district-fetcher';
import PSSService from '../services/PSSService';
import HCNService from '../services/HCNService';

const fetcherMiddleware = createFetcherMiddleware({
  pssService: store => new PSSService(store),
  hcnService: store => new HCNService(store),
});
const middleware = [thunk, fetcherMiddleware];

const enhancers =
  (__DEV__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
export default enhancers(applyMiddleware(...middleware));
